/**
 * Check if user's email domain is a corporate domain (not free email provider)
 * Endpoint: GET /signup/i/is_corp_domain/
 *
 * The backend:
 * - User must be authenticated
 * - Extracts user's email domain (part after @)
 * - Checks if domain is NOT in FREE_DOMAIN_SET (gmail, yahoo, hotmail, etc.)
 *
 * Returns:
 * - true  → user has a corporate email domain
 * - false → user has a free email domain or request failed
 */

export const isCorpDomain = async () => {
  return fetch('/signup/i/is_corp_domain/')
    .then((response) => {
      if (!response.ok) {
        return {
          result: false,
        };
      }
      return response.json();
    })
    .then((res) => res.result)
    .catch((e) => {
      console.error(e);
      return false;
    });
};
